import { apiClient } from "../services/apiClient";
import { ATP_API_URL } from "../config/apiConfig";

/**
 * Approves an entity.
 * POST api/Onboarding/approve-entity
 * Body: { entityPrimaryId, email, spocEmail }
 */
export const approveEntityAction = async ({
  entityPrimaryId,
  email,
  spocEmail,
}) => {
  try {
    const payload = {
      entityPrimaryId: entityPrimaryId || 0,
      email: email || "",
      spocEmail: spocEmail || "",
    };

    // console.log("[Approve] payload:", payload);

    const response = await apiClient.post(
      ATP_API_URL.APPROVE_ENTITY_NEW,
      payload,
    );

    if (response?.status === 200) {
      if (response.data?.success === false) {
        return {
          success: false,
          message: response.data.message || "Failed to approve entity",
        };
      }
      return {
        success: true,
        message: response.data?.message || "Entity approved successfully",
      };
    }

    return { success: false, message: "Failed to approve entity" };
  } catch (error) {
    console.error("[Approve] error:", error);
    return {
      success: false,
      message: error.message || "Failed to approve entity",
    };
  }
};
